<template>
    <div>
        <Modal class-name="vertical-center-modal" :value="showModel" :title="title" :footer-hide="true"
            :mask-closable="false" @on-cancel="cancel" @on-visible-whetherSync="openOrClose"
            :styles="{ 'min-width': '960px' }">


            <Upload type="drag" :before-upload="handleBeforeUpload" accept=".xls, .xlsx" action="">
                <div style="padding: 20px 0">
                    <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                    <p>Click file here to upload</p>
                </div>
            </Upload>

            <div v-show="tableData.length">
                <Table style="width: 100%;margin-top: 30px;" id="mytable" width="960" height="200" :columns="tableTitle"
                    :data="tableData" :loading='tableLoading' ></Table>

                <div style="text-align:center;margin-top: 10px;">
                    <!-- <Checkbox v-model="whetherSync">{{ $t('productPage.mulLang.whetherSync') }}</Checkbox> -->
                    <div v-show="!allowUpload">
                        <div>提示1:hyeco平台数据需要编辑完全后才可导入</div>
                        <!-- <div>提示2:wordCode为数字、字母或者下划线组成的字符串。其他不可以为空，可以输入一个空格</div> -->
                    </div>
                </div>
            </div>

          


            <div class="flexCC" style="margin-top: 30px;">
                <Button :loading="disabled" :disabled="!tableData.length || !allowUpload" type="primary"
                    @click="modalTip = true" style="margin-right:20px">{{ $t('BasicProduct.funcBox.add') }}</Button>
                <Button :disabled="disabled" @click="cancel">{{ $t('cancel') }}</Button>
                <!-- <Button :disabled="disabled" @click="savetoexcel">{{$t('cancel')}}</Button> -->
            </div>

            <Modal class-name="vertical-center-modal" v-model="modalTip" title="Tip 提示" @on-cancel="modalTip = false"
                @on-ok="subData" :ok-text="$t('confirm')" :cancel-text="$t('cancel')" width="300">
                <p>{{ $t("BasicProduct.funcBox.tipContent") }}</p>
            </Modal>

        </Modal>
    </div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import * as XLSX from 'xlsx/xlsx.mjs';
import common from '@/common/common';
import excel from '@/common/excel'
import { mapState } from 'vuex'

export default {
    props: {
        showModel: Boolean,
        fn: Function,
        basicTypeId: Number,
        dataType:String
    },
    name: "ModelImport",
    components: {
    },
    data() {
        return {
            disabled: false,//禁用确定按钮
            title: '',//弹框标题
            content: "",
            file: {},
            tableData: [],
            jsonData: [],
            tableTitle: [],
            uploadLoading: false,
            tableLoading: false,
            showRemoveFile: false,
            showProgress: false,
            progressPercent: 0,
            whetherSync: true,
            modalTip: false,
            totalCount: 0,
            successCount: 0,
            failCount: 0,
            finish: false,
            allowUpload: true
        }
    },

    computed: {
        ...mapState(['selectId', 'showChildrenSide']),

    },
    created() {
    },
    mounted() {
    },
    watch: {
        showModel(val) {
            if (val == true) {

                this.title = this.$t("productPage.mulLang.importTip")
            } else {
                this.resetForm();//重置表单
            }

        },
    },
    methods: {
        handleBeforeUpload(file) {
            const fileExt = file.name.split('.').pop().toLocaleLowerCase()
            if (fileExt === 'xlsx' || fileExt === 'xls') {
                this.readFile(file)

                this.file = file
            } else {
                this.$Notice.warning({
                    title: '文件类型错误',
                    desc: '文件：' + file.name + '不是EXCEL文件，请选择后缀为.xlsx或者.xls的EXCEL文件。'
                })
            }
            return false
        },
        readFile(file) {
            const reader = new FileReader()
            reader.readAsArrayBuffer(file)
            reader.onloadstart = e => {
                this.uploadLoading = true
                this.tableLoading = true
                this.showProgress = true
            }
            reader.onprogress = e => {
                this.progressPercent = Math.round(e.loaded / e.total * 100)
            }
            reader.onerror = e => {
                this.$Message.error(this.$t("productPage.mulLang.readF"))
            }
            reader.onload = e => {
                this.$Message.info(this.$t("productPage.mulLang.readS"))
                const data = e.target.result
                const {
                    header,
                    results
                } = excel.read(data, 'array')

                let filedArrHyeco = ["basicTypeId","chooseToUse","conUiCode","conditionJudgment","defaultValue","descr","formatContent","formatType","id","identifier","keyName","offlineOperation","propertyId","readWrite","remark","required","senseAction","senseCondition","sortNumber","taskUiCode","whetherMajor"]
                let filedArrBasic = ["basicTypeId","chooseToUse","conUiCode","conditionJudgment","defaultValue","descr","formatContent","formatType","hexValueBytes","id","keyId","keyName","keyType","offlineOperation","propertyId","readWrite","remark","required","senseAction","senseCondition","sortNumber","taskUiCode","whetherMajor"]
                let filedArr = this.dataType=='hyeco'?filedArrHyeco:filedArrBasic

                const tableTitle = header.map(item => {
                    return {
                        title: item,
                        key: item,
                        minWidth: 220,
                        render: (h, params) => {
                            let itemObj = params.row
                            let flag = 1
                            let colorObj = { '1': '#5a516e', '2': '#ed4014' }
                            let reg = /^\w+$/;

                            // if (itemObj['wordCode'] && !reg.test(itemObj['wordCode'])) {
                            //     flag = 2;
                            //     this.allowUpload = false
                            // }

                            // repeatCode.map(item => {
                            //     if (itemObj['wordCode'] == item) {
                            //         flag = 2;
                            //         this.allowUpload = false
                            //     }
                            // })

                            // filedArr.map(sitem => {
                            //     if (!itemObj[sitem]) {
                            //         flag = 2;
                            //         this.allowUpload = false
                            //     }
                            // })

                            if(!itemObj['keyName']){
                                flag = 2;
                                this.allowUpload = false
                            }
                            let style = {
                                color: colorObj[flag]
                            }
                            return h('div', { style }, params.row[item])
                        }
                    }
                })

                




                this.tableData = results.map(item => {
                  
                    item.addFlag = true
                    if (!item['keyName']) {
                        item.addFlag = false
                    }

                    if(this.dataType=='basci' && (item.keyType ==4 || item.keyType ==5)){
                        item.addFlag = false
                    }

                    if (item.addFlag) {
                        this.totalCount += 1
                    }


                    // item.cellClassName = {wordCode:''}
                    item.id = null
                    item.basicTypeId = this.basicTypeId
                    return item
                })

                console.log('this.dataType',this.dataType)
                console.log('this.totalCount',this.totalCount)
                if(this.dataType=='basci'){
                    this.tableData = this.tableData .filter(item=>{
                        return item.keyType !=4 && item.keyType !=5
                    })
                }

                this.tableTitle = tableTitle
                this.disabled = false
                this.uploadLoading = false
                this.tableLoading = false
                this.showRemoveFile = true
                this.readExcel(file)
            }
        },
        readExcel(file) {
            // 表格导入
            const fileReader = new FileReader()
            fileReader.onload = ev => {
                try {
                    const data = ev.target.result
                    const workbook = XLSX.read(data, {
                        type: "binary"
                    })
                    const wsname = workbook.SheetNames[0] // 取第一张表
                    const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]) // 生成json表格内容
                    this.jsonData = ws
                    this.content = JSON.stringify(ws)

                } catch (e) {
                    // console.log('e',e)
                    return false
                }
            }
            fileReader.readAsBinaryString(file)
        },
        openOrClose(value) {

            if (value === false) {
                this.resetForm();//重置表单

            }
        },
        async subDataOld() {//提交表单
            console.log(this.tableData)
            this.disabled = true


            let opreateArr = this.tableData
      

            let refreshIndex = opreateArr.length - 1; // 刷新次数索引
            // 用forEach/map的方式刷新太快，无法通过延时知道那个接口失败了。现在改用for循环+async+await+Promise的方式进行设备刷新。

            for(let i=0;i<opreateArr.length;i++){

                let params = {
                    ...opreateArr[i],  basicTypeId: this.basicTypeId 
                }
                delete params.cellClassName
                delete params.addFlag

                console.log('params',params)
             
                let refreshResultValue = await this.axios.post(this.config.urlArray.createLoraKey, {...params });
                // console.log('refreshResultValue',refreshResultValue)
                if (refreshResultValue.data.code == 1) {
                    this.successCount += 1
                    // continue;
                } else {
                    let msgContent = refreshResultValue.data.message ? `功能${i}创建失败,${refreshResultValue.data.message}` : `功能${i}创建失败`
                    common.msg('error', msgContent, () => {
                        this.failCount += 1
                    })
                    this.tableData.map((sitem)=>{
                        if(opreateArr[i]['keyId']==sitem.keyId){
                            sitem.cellClassName = {keyId:'table-info-err'}
                        }

                        return sitem
                    })

                }
                // console.log('index',index)

                // 判断是否全部设备刷新完成
                if (i == refreshIndex) {
                    common.msg('success', this.$t("productPage.mulLang.finish"), () => {
                        // console.log(1111111)
                        this.disabled = false
                        this.finish = true

                        if (this.successCount == this.totalCount) {
                            this.cancel()
                        }


                    })
                    return
                }

            }
        },
      
        async subData() {//提交表单
            console.log(this.tableData)
            this.disabled = true

            // let res = await this.axios.post(this.config.urlArray.excelImportKeys, [...this.tableData]);

            // if(res.data.code==1){
            //     common.msg('success', this.$t("productPage.mulLang.finish"), () => {
            //         // console.log(1111111)
            //         this.disabled = false
            //         this.finish = true
            //         this.cancel()
            //     })
            // }

            this.axios.post(this.config.urlArray.excelImportKeys, [...this.tableData]).then((result) => {
                    
                    common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                        
                        this.disabled = false
                        this.finish = true
                        this.cancel()
                        
                    },()=>{
                        this.disabled = false
                        this.finish = true
                    })
                    
                    
                })
      

        },
      
        cancel() {//对话框关闭
            this.resetForm();//重置表单
            this.fn()
            this.$emit('update:showModel', false);
        },
        resetForm() {//重置表单
            // this.$refs.formData.resetFields();//重置表单
            this.content = "";
            this.file = {};
            this.tableData = [];
            this.jsonData = [];
            this.tableTitle = [];
            this.uploadLoading = false;
            this.tableLoading = false;
            this.showRemoveFile = false;
            this.showProgress = false;
            this.progressPercent = 0
            this.modalTip = false;
            this.totalCount = 0;
            this.successCount = 0;
            this.failCount = 0;
            this.disabled = false;//恢复提交按钮为激活状态
            this.finish = false;
            this.allowUpload = true;
            this.whetherSync = true;

        }
    }
}
</script>

<style>
.ivu-table .table-info-err{
        background-color: #ed4014;
}
</style>
<style lang='less' scoped>


/deep/ .vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;

    .ivu-modal {
        top: 0;
    }

}

.changeBox {
    /deep/ .ivu-form-item-content {
        margin-left: 0 !important;
        text-align: center;

    }

}

</style>

